import { CashbackRewardsPageTemplate } from "./template";
import { useCashbackRewardsPage } from "./logic";

export const CashbackRewardsPage = () : JSX.Element => {
    const props = useCashbackRewardsPage();

    return (
        <CashbackRewardsPageTemplate {...props}/>
    )
}